// extracted by mini-css-extract-plugin
export var container = "post-preview-module--container--sKqyH";
export var imageWrapper = "post-preview-module--image-wrapper--uoJqF";
export var little = "post-preview-module--little--fyD3t";
export var ratio = "post-preview-module--ratio--ukCzq";
export var tagsWrapper = "post-preview-module--tags-wrapper--vrqCs";
export var titleText = "post-preview-module--title-text--uQ5Pv";